import { createSlice } from "@reduxjs/toolkit";

const contextualLoaderSlice = createSlice({
  name: "contextualLoader",
  initialState: {
    loading: false,
    error: null,
    message: "",
    loaderType: null,
    statusCode: null,
  },
  reducers: {
    showContextualLoader: (state, action) => {
      state.loading = true;
      state.error = null;
      state.message = action.payload.message;
      state.loaderType= action.payload.loaderType
      state.statusCode= null;
    },
    hideContextualLoader: (state) => {
      state.loading = false;
      state.error = null;
      state.message = "";
      state.loaderType = null;
      state.statusCode= null;
    },
    showContextualError: (state, action) => {
      state.loading = false;
      state.error = action.payload.errorType; // "api" or "network"
      state.message = action.payload.message;
      state.loaderType = null;
      state.statusCode=action.payload?.statusCode;
    },
  },
});

export const {
  showContextualLoader,
  hideContextualLoader,
  showContextualError,
} = contextualLoaderSlice.actions;

export default contextualLoaderSlice.reducer;
